import React from "react";

import { useParams } from "react-router-dom";

import styles from "../Item.module.css";
import detailImg from "./cleanterbox_detail.jpg";

export default function Cleanterbox() {
  const { category } = useParams();

  if (category === "item") {
    return (
      <div className={styles.ItemContainer}>
        <img src={detailImg} alt="cleanterbox_detail.jpg" />
      </div>
    );
  }
}
